import { createContext, ReactNode, useState, useEffect } from 'react';
import { Layout } from 'antd-v3';

import { isCollapsedFromStorage, storeCollapsed } from '@providers/LayoutProvider/utils';

export interface LayoutContextData {
  collapsed: boolean;
  toggleSideMenu: () => void;
}

export const contextDefaultValue: LayoutContextData = {
  collapsed: isCollapsedFromStorage(),
  toggleSideMenu: () => {}
};

const useLayoutContextValue = (): LayoutContextData => {
  const [collapsed, setCollapsed] = useState<boolean>(isCollapsedFromStorage());
  const toggleSideMenu = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    storeCollapsed(collapsed);
  }, [collapsed]);

  return {
    collapsed,
    toggleSideMenu
  };
};

export const LayoutContext = createContext<LayoutContextData>(contextDefaultValue);
interface Props {
  children: ReactNode;
}

export const LayoutProvider = ( { children }: Props) => {
  const contextValue = useLayoutContextValue();

  return (
    <LayoutContext.Provider value={contextValue}>
      <Layout className='main-layout' hasSider style={{ minHeight: '100vh' }}>
        {children}
      </Layout>
    </LayoutContext.Provider>
  );
};
